import { render, staticRenderFns } from "./WarehousesPlanForm.vue?vue&type=template&id=70a99f28&"
import script from "./WarehousesPlanForm.vue?vue&type=script&lang=ts&"
export * from "./WarehousesPlanForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports